import { FRFloor } from '@/_models/virtualStaging/FRFloor';
import { getQueryVariable } from '../util';
import AdminAPI from '../../api/TreedisAdminDAO';
import { getSweeps } from '@/api/queries';
export const afterSweepsInit = async ({
  sweeps,
  matterId,
  slug,
  iframeUrl,
  setData,
  cb,
}: {
  sweeps: any[];
  matterId: string | number;
  slug: string;
  iframeUrl: string;
  setData?: ({ floors, deprecatedSweeps }: { floors: any[]; deprecatedSweeps?: any[] }) => void;
  cb?: () => void;
}) => {
  if (sweeps?.length) {
    const floors: FRFloor[] = [];
    const isMatterportLink = getQueryVariable(iframeUrl, 'm') !== matterId;
    const frFloorsRes = !isMatterportLink ? await AdminAPI.getFRFloors(slug) : { data: [] };
    // using sweep.floor_position to get the floor height position
    sweeps.forEach((sweep) => {
      if (!floors[sweep.floor_index]) {
        const frFloor = frFloorsRes?.data.find((i: any) => i.floor === sweep.floor_index);

        const floor = {
          floor: sweep.floor_index,
          position: sweep.floor_position,
        };
        floors[sweep.floor_index] = frFloor
          ? new FRFloor({
              ...frFloor,
              ...floor,
            })
          : new FRFloor(floor);
      }
      floors[sweep.floor_index].sweeps?.push(sweep);
    });
    const actualMatterId = getQueryVariable(iframeUrl, 'm') || matterId;
    const deprecatedSweeps = await getSweeps(String(actualMatterId), slug);
    setData({
      deprecatedSweeps,
      floors,
    });
  }

  cb();
};
